<template>
  <AutoRefresh :callback="callback" :updatedAt="data.generatedAt" />
  <ContainerAlerts v-if="data.alerts.length" class="host-alerts" :alerts="data.alerts" />
  <InfraBand :data="data" :history="history" />
  <InfraHistory :refreshedAt="data.generatedAt" :callback="setHistory" />
  <div class="charts">
    <StatisticsCard :span="12" title="Containers par niveau" subtitle="Fronts, passerelle puis back : le chemin que suit chaque appel, avec l'état et la consommation de chaque container">
      <ContainerTopology :containers="data.containers" :thresholds="data.thresholds" />
    </StatisticsCard>
  </div>
</template>

<script>
import StatisticsCard from "@/statistics/components/StatisticsCard.vue";
import AutoRefresh from "@/administration/components/AutoRefresh.vue";
import ContainerAlerts from "@/administration/components/ContainerAlerts.vue";
import ContainerTopology from "@/administration/components/ContainerTopology.vue";
import InfraBand from "@/administration/components/InfraBand.vue";
import InfraHistory from "@/administration/components/InfraHistory.vue";

/**
 * Vue d'ensemble des containers : le bandeau (containers, machine hôte, consommation), le graphique de consommation de toute l'infrastructure dans le temps, puis les containers, dans un encadré, en trois niveaux (fronts, passerelle, back) avec leurs liens.
 * callback : recharge les mesures.
 */
export default {
  name: 'ContainersOverview',
  components: {StatisticsCard, AutoRefresh, ContainerAlerts, ContainerTopology, InfraBand, InfraHistory},
  props: {
    data: {type: Object, required: true},
    callback: {type: Function, required: true},
  },
  data() {
    return {
      // L'historique chargé par le graphique, repris par le bandeau pour la consommation actuelle et les pics
      history: null,
    };
  },
  methods: {
    setHistory(history) {
      this.history = history;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/statistics/style/statistics.styl';

.host-alerts
  margin-bottom 14px
</style>
